/**
 * Generated by orval 🍺
 * Do not edit manually.
 * CliniShift Manager
 * The CliniShift Manager API is used to manage the CliniShift platform. This API is used by the CliniShift Manager Portal.
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const NotificationType = zod.enum(['shift.offer.applied', 'shift.offer.approved', 'shift.filled', 'shift.unfilled', 'shift.assignment.assigned', 'shift.assignment.unassigned', 'time_off.request.created', 'time_off.request.responded', 'time_off.request.approved', 'broadcast.received', 'join_request.created']).describe('Dotted notification type. Filters accept exact values or a prefix such as `shift.offer.*`.');

export type NotificationType = zod.input<typeof NotificationType>;
export type NotificationTypeOutput = zod.output<typeof NotificationType>;
